/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchView_viewer$ref = any;
export type OrderBy = {|
  direction: string,
  field: string,
|};
export type routes_SearchView_QueryVariables = {|
  count: number,
  cursor?: ?string,
  query: string,
  filters?: ?string,
  orderBy?: ?OrderBy,
  page?: ?number,
|};
export type routes_SearchView_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchView_viewer$ref
  |}
|};
export type routes_SearchView_Query = {|
  variables: routes_SearchView_QueryVariables,
  response: routes_SearchView_QueryResponse,
|};
*/


/*
query routes_SearchView_Query(
  $count: Int!
  $cursor: String
  $query: String!
  $filters: String
  $orderBy: OrderBy
  $page: Int
) {
  viewer {
    ...SearchView_viewer_1MtKB9
    id
  }
}

fragment CmsBanner_viewer on Customer {
  cmsBanners(first: 999) {
    edges {
      node {
        id
        title
        link
        urlPaths
        categoryBig
        categorySmall
      }
    }
  }
}

fragment List_viewer on Customer {
  id
  ...ProductCard_viewer
}

fragment ProductCard_product on Product {
  id
  alerts
  name
  type
  configurables(first: 99) {
    edges {
      node {
        id
        type
        discountCode
        name
        model
        secondModel
        sku
        regularPrice
        price
        priceMatch
        sellable
        nonStock
      }
    }
  }
  model
  secondModel
  regularPrice
  price
  priceDrop
  sku
  urlSlug
  freeShipping
  priorityShipping {
    getByDate
  }
  globalFreeShipping
  preorderDate
  backInStockDate
  nonStock
  onlineOnly
  callForPrice
  inStoreOnly
  sellable
  clearance
  discountCode
  brand {
    id
    name
  }
  loyaltyPoints {
    accruing
    dollars
  }
  bonusProducts(first: 999) {
    edges {
      node {
        productId
        productName
        productUrlSlug
        price
        quantity
        optional
        id
      }
    }
  }
  labels(first: 999) {
    edges {
      node {
        id
        imageUrl
        placement
        type
      }
    }
  }
  mainImage {
    id
    thumbnail
  }
}

fragment ProductCard_viewer on Customer {
  id
  freeShippingAmount
}

fragment SearchView_viewer_1MtKB9 on Customer {
  ...List_viewer
  ...CmsBanner_viewer
  configs
  products(first: $count, orderBy: $orderBy, after: $cursor, query: $query, filters: $filters, page: $page) {
    totalCount
    facets {
      __typename
      __isFacetType: __typename
      ... on Facet {
        key
        name
        position
        buckets {
          key
          docCount
          imageUrl
        }
      }
      ... on FacetStats {
        key
        name
        position
        buckets {
          key
          docCount
          to
          from
        }
        max
        min
      }
    }
    canonicalLink
    redirect
    edges {
      node {
        id
        ...ProductCard_product
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v6 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v7 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v8 = {
  "kind": "Variable",
  "name": "page",
  "variableName": "page"
},
v9 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "docCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountCode",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secondModel",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regularPrice",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellable",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nonStock",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_SearchView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "SearchView_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "routes_SearchView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeShippingAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "CmsBannerConnection",
            "kind": "LinkedField",
            "name": "cmsBanners",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CmsBannerEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsBanner",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "link",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlPaths",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categoryBig",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categorySmall",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "cmsBanners(first:999)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "facets",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isFacetType"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Bucket",
                        "kind": "LinkedField",
                        "name": "buckets",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Facet",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Bucket",
                        "kind": "LinkedField",
                        "name": "buckets",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "to",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "from",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "max",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "min",
                        "storageKey": null
                      }
                    ],
                    "type": "FacetStats",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canonicalLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "redirect",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alerts",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 99
                          }
                        ],
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "configurables",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v15/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "priceMatch",
                                    "storageKey": null
                                  },
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "configurables(first:99)"
                      },
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceDrop",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlSlug",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "freeShipping",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriorityShipping",
                        "kind": "LinkedField",
                        "name": "priorityShipping",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "getByDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "globalFreeShipping",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "preorderDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backInStockDate",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "onlineOnly",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "callForPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "inStoreOnly",
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clearance",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Brand",
                        "kind": "LinkedField",
                        "name": "brand",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoyaltyPoints",
                        "kind": "LinkedField",
                        "name": "loyaltyPoints",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accruing",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dollars",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "BonusProductConnection",
                        "kind": "LinkedField",
                        "name": "bonusProducts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BonusProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BonusProduct",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "productId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "productName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "productUrlSlug",
                                    "storageKey": null
                                  },
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "quantity",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "optional",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "bonusProducts(first:999)"
                      },
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "LabelConnection",
                        "kind": "LinkedField",
                        "name": "labels",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Label",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "placement",
                                    "storageKey": null
                                  },
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "labels(first:999)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductImage",
                        "kind": "LinkedField",
                        "name": "mainImage",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "filters": [
              "orderBy",
              "query",
              "filters",
              "page"
            ],
            "handle": "connection",
            "key": "SearchView_products",
            "kind": "LinkedHandle",
            "name": "products"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0fefd7b6a34589e71522bde8871e749e",
    "id": null,
    "metadata": {},
    "name": "routes_SearchView_Query",
    "operationKind": "query",
    "text": "query routes_SearchView_Query(\n  $count: Int!\n  $cursor: String\n  $query: String!\n  $filters: String\n  $orderBy: OrderBy\n  $page: Int\n) {\n  viewer {\n    ...SearchView_viewer_1MtKB9\n    id\n  }\n}\n\nfragment CmsBanner_viewer on Customer {\n  cmsBanners(first: 999) {\n    edges {\n      node {\n        id\n        title\n        link\n        urlPaths\n        categoryBig\n        categorySmall\n      }\n    }\n  }\n}\n\nfragment List_viewer on Customer {\n  id\n  ...ProductCard_viewer\n}\n\nfragment ProductCard_product on Product {\n  id\n  alerts\n  name\n  type\n  configurables(first: 99) {\n    edges {\n      node {\n        id\n        type\n        discountCode\n        name\n        model\n        secondModel\n        sku\n        regularPrice\n        price\n        priceMatch\n        sellable\n        nonStock\n      }\n    }\n  }\n  model\n  secondModel\n  regularPrice\n  price\n  priceDrop\n  sku\n  urlSlug\n  freeShipping\n  priorityShipping {\n    getByDate\n  }\n  globalFreeShipping\n  preorderDate\n  backInStockDate\n  nonStock\n  onlineOnly\n  callForPrice\n  inStoreOnly\n  sellable\n  clearance\n  discountCode\n  brand {\n    id\n    name\n  }\n  loyaltyPoints {\n    accruing\n    dollars\n  }\n  bonusProducts(first: 999) {\n    edges {\n      node {\n        productId\n        productName\n        productUrlSlug\n        price\n        quantity\n        optional\n        id\n      }\n    }\n  }\n  labels(first: 999) {\n    edges {\n      node {\n        id\n        imageUrl\n        placement\n        type\n      }\n    }\n  }\n  mainImage {\n    id\n    thumbnail\n  }\n}\n\nfragment ProductCard_viewer on Customer {\n  id\n  freeShippingAmount\n}\n\nfragment SearchView_viewer_1MtKB9 on Customer {\n  ...List_viewer\n  ...CmsBanner_viewer\n  configs\n  products(first: $count, orderBy: $orderBy, after: $cursor, query: $query, filters: $filters, page: $page) {\n    totalCount\n    facets {\n      __typename\n      __isFacetType: __typename\n      ... on Facet {\n        key\n        name\n        position\n        buckets {\n          key\n          docCount\n          imageUrl\n        }\n      }\n      ... on FacetStats {\n        key\n        name\n        position\n        buckets {\n          key\n          docCount\n          to\n          from\n        }\n        max\n        min\n      }\n    }\n    canonicalLink\n    redirect\n    edges {\n      node {\n        id\n        ...ProductCard_product\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '68d133dcc3f6ed7b590c1fc584ad422a';

module.exports = node;
